<script>
import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "../dataAdvancedtable";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Nueva Tarjeta",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      checked: true,
      checked1: false,
      active: 1,
      lastFolio: "",
      empresas: [],
      municipios: [],
      puntos_entrega: [],
      objeto: {
        folio: "",
        id_empresa: "",
        estatus: true,
        estatus_entrega: false,
      },
      inactive: false,


      // ************************************** Link
      tableData: tableData,
      title: "Nueva Tarjeta",
      items: [
        {
          text: "Tarjetas",
          href: "/Tarjetas",
        },
        {
          text: "Nueva Tarjeta",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
    };
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    label() {
      return this.objeto.estatus ? 'On' : 'Off';
    },
    label1() {
      return this.objeto.estatus_entrega ? 'On' : 'Off';
    },
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {
    axios
      .get(
        "https://bdd7w9ysj6.execute-api.us-west-1.amazonaws.com/app/masivaScreen"
      )
      .then((res) => {
        const {
          empresas = [],
          ultimo_folio = "",
          puntos_entrega = [],
          municipios = [],
        } = res.data;
        this.lastFolio = ultimo_folio;
        this.puntos_entrega = puntos_entrega;
        this.empresas = empresas;
        this.municipios = municipios;
      })
      .catch((err) => {
        console.log(err);
      });

    this.checked = Boolean(this.active);
    // Podemos reutilizar la función update ya que el código es el mismo.

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    setTimeout(() => {
      this.showModal = true;
    }, 1500);
  },

  methods: {
    ...todoMethods,
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },

    handleSubmit() {
      this.objeto.estatus = this.objeto.estatus ? 1 : 0;
      this.objeto.estatus_entrega = this.objeto.estatus_entrega ? 1 : 0;
      const payload = JSON.stringify(this.objeto);
      console.log(payload)
      axios
        .post("/tarjetas", payload)
        .then((res) => {
          const { response = "" } = res.data;
          if (response === true) {
            this.$swal(
              "Registro",
              "La Tarjeta ha sido creada con exito.",
              "success"
            );
            this.$router.push("/Tarjetas");
          } else {
            this.$swal("Alerta", "No se ha podido crear", "warning");
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          this.$swal("Error", "Ocurrio un error", "error");
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-12">
                <h4 class="card-title">Nueva Tarjeta</h4>
              </div>
              <div class="col-sm-12 col-md-5"></div>
              <div class="row mt-4">
                <div class="col-sm-12 col-md-8">
                  <b
                    ><label class="form-check-label"
                      >Último folio creado</label
                    ></b
                  >
                  <div class="mb-4">
                    <b-form-input
                      v-model="lastFolio"
                      id="lastFolio"
                      placeholder="49999999"
                      disabled
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-sm-12 col-md-1"></div>
                <div class="col-sm-12 col-md-1">
                  <b> <label class="form-check-label">Estado</label> </b>
                  <br />
                  <br />
                  <label class="switch" role="button">
                    <input
                      type="checkbox"
                      :value="objeto.estatus"
                      v-model="objeto.estatus"
                    />
                    <div
                      class="circle"
                      :class="{
                        'circle-on': objeto.estatus,
                        'circle-off': !objeto.estatus,
                      }"
                    >
                      <span>{{ label }}</span>
                    </div>
                  </label>
                </div>

                <div class="col-sm-12 col-md-2">
                  <b>
                    <label class="form-check-label">Marcar como perdida</label>
                  </b>
                  <br />
                  <br />
                  <label class="switch" role="button">
                    <input
                      type="checkbox"
                      :value="objeto.estatus_entrega"
                      v-model="objeto.estatus_entrega"
                    />
                    <div
                      class="circle"
                      :class="{
                        'circle-on': objeto.estatus_entrega,
                        'circle-off': !objeto.estatus_entrega,
                      }"
                    >
                      <span>{{ label1 }}</span>
                    </div>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-8">
                <b> <label class="form-check-label">Folio</label> </b>
                <div class="mb-4">
                  <b-form-input
                    v-model="objeto.folio"
                    id="folio"
                    placeholder="0000000099"
                  ></b-form-input>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-sm-12 col-md-4">
                  <b><label class="form-check-label">Fecha de entrega</label></b>
                  <div class="mb-4">
                    <b-form-input
                      v-model="objeto.fecha_entrega"
                      id="fecha_entrega"
                      type="date"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-sm-12 col-md-2">
                  <b><label class="form-check-label">Hora de entrega</label></b>
                  <div class="mb-4">
                    <b-form-input
                      v-model="objeto.hora_entrega"
                      id="hora_entrega"
                      type="time"
                    ></b-form-input>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4">
                  <b><label class="form-check-label">Fecha de compromiso de entrega</label></b>
                  <div class="mb-4">
                    <b-form-input
                      v-model="objeto.fecha_compromiso"
                      id="fecha_compromiso"
                      type="date"
                    ></b-form-input>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-8">
                <b><label class="form-check-label">Empresa, institución o dependencia</label></b>
                <div class="mb-4">
                  <b-form-select
                    class="form-select"
                    v-model="objeto.id_empresa"
                    size="lg"
                  >
                    <option
                      v-for="empresa in empresas"
                      :key="empresa.id_empresa"
                      :value="empresa.id_empresa"
                    >
                      {{ empresa.nombre }}
                    </option>
                  </b-form-select>
                </div>
              </div>

              <!-- <div class="col-sm-12 col-md-8">
                <b><label class="form-check-label">Municipio</label></b>
                <div class="mb-4">
                  <b-form-select
                    class="form-select"
                    v-model="objeto.id_municipio"
                    size="lg"
                  >
                    <option
                      v-for="municipio in municipios"
                      :key="municipio.id_municipio"
                      :value="municipio.id_municipio"
                    >
                      {{ municipio.nombre }}
                    </option>
                  </b-form-select>
                </div>
              </div> -->

              <!-- <div class="col-sm-12 col-md-8">
                <b><label class="form-check-label">Punto de entrega</label></b>
                <div class="mb-4">
                  <b-form-select
                    class="form-select"
                    v-model="objeto.id_punto_entrega"
                    size="lg"
                  >
                    <option
                      v-for="punto in puntos_entrega"
                      :key="punto.id_punto_entrega"
                      :value="punto.id_punto_entrega"
                    >
                      {{ punto.nombre }}
                    </option>
                  </b-form-select>
                </div>
              </div> -->

              <v-row>
                <v-col md="12">
                  <v-btn
                    color="primary"
                    type="button"
                    v-on:click="handleSubmit()"
                  >
                    Guardar
                  </v-btn>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <router-link to="/Tarjetas">
                    <v-btn color="error" type="button"> Cancelar </v-btn>
                  </router-link>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
$default: black;
$active: #2dc772;
$inactive: #6c757d;
$text: #9d9d9d;
$text-hover: white;
$size: 0.7rem;
$w: 60px;
$h: 25px;
$circle: $h - 4;
$toggle-dis: $w - $circle - 2;

.switch {
  position: relative;
  display: inline-block;
  width: $w;
  height: $h;
  border-radius: 100px;

  .circle {
    display: flex;
    align-items: center;
    width: 100%;
    height: $h - 1;
    border-radius: 100px;
    background-color: $default;

    & > span {
      font-size: $size;
      color: $text;
      padding-left: $h + -6;
    }

    &::before {
      position: absolute;
      content: "";
      height: $circle;
      width: $circle;
      left: 1px;
      top: 1px;
      border-radius: 100px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &:hover {
      background-color: lighten($default, 20);

      & > span {
        color: $text-hover;
      }
    }
  }

  .circle-on {
    background-color: $active;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $active solid;

      &::before {
        background-color: $active;
      }

      & > span {
        color: $active;
      }
    }
  }

  .circle-off {
    background-color: $inactive;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $inactive solid;

      &::before {
        background-color: $inactive;
      }

      & > span {
        color: $inactive;
      }
    }
  }

  & input {
    display: none;

    &:checked + .circle:before {
      -webkit-transform: translateX($toggle-dis);
      -ms-transform: translateX($toggle-dis);
      transform: translateX($toggle-dis);
    }
  }
}
</style>